export const AI_WORKSPACE_QUERY_KEYS = {
  SEARCH: "searchAIWorkspace",
  GET: "getAIWorkspace",
  REQUESTS: "getAIWorkspaceRequests",
  REQUEST: "getAIWorkspaceRequest",
  CREATOR_SCRIPT_JOB: "creatorScriptGeneratorJob",
};
